import React, { useContext, useState } from 'react';
import { logEventClickFromSearch } from './requests';
import { useSDKFeatureFlag } from './splitio';
import { SearchRetrievalContext } from './types';

const defaultRetrievalContext: SearchRetrievalContext = {
    date_filter: null,
    query_terms: null,
    is_online: null,
    place_id: null,
    latitude: null,
    longitude: null,
    search_id: null,
};

const RetrievalContext = React.createContext({
    retrievalContext: defaultRetrievalContext,
    shouldUseSDK: false,
    // eslint-disable-next-line @typescript-eslint/no-unused-vars
    eventClickTracker: (id: string, position: number) => {
        // noop, will be replaced in context when app initializes
    },
});

export function SearchRetrievalContextProvider(props: {
    // TODO eventSearch type
    eventSearch: any;
    searchId: string;
    children: React.ReactNode;
}) {
    // Note: Use state here due to: https://reactjs.org/docs/context.html#caveats
    const [retrievalContext] = useState({
        date_filter: props.eventSearch.dates || null,
        query_terms: props.eventSearch.q || null,
        is_online: props.eventSearch.onlineEventsOnly,
        place_id: Array.isArray(props.eventSearch.places)
            ? props.eventSearch.places[0]
            : null,
        latitude: null,
        longitude: null,
        search_id: props.searchId,
    });
    const shouldUseSDK = useSDKFeatureFlag();

    if (shouldUseSDK === null) {
        return <>{props.children}</>;
    }

    return (
        <RetrievalContext.Provider
            value={{
                retrievalContext,
                shouldUseSDK,
                eventClickTracker: (id, position) => {
                    if (!shouldUseSDK) return;

                    logEventClickFromSearch(id, position, retrievalContext);
                },
            }}
        >
            {props.children}
        </RetrievalContext.Provider>
    );
}

export function useSearchRetrievalContext() {
    const searchRetrievalContext = useContext(RetrievalContext);

    return searchRetrievalContext;
}

export function useEventClickTracker() {
    const searchRetrievalContext = useContext(RetrievalContext);

    return searchRetrievalContext.eventClickTracker;
}
